<template>
<div class="chapter">
<div class="inner_page">
<p class="sp-fm" id="epig"> </p>
<p class="vep"><span class="epub-i">Snow is white and lieth in the dike,</span></p>
<p class="vep"><span class="epub-i">And every man lets it lie;</span></p>
<p class="vep"><span class="epub-i">Pepper is black and hath a good smack,</span></p>
<p class="vep"><span class="epub-i">And every man doth it buy.</span></p>
<p class="vepc">—A “COMMONPLACE BOOK” OF THE FIFTEENTH CENTURY</p>
<p class="ep"><span class="epub-i">… we were “not so much sub-continent as sub-condiment,” as my distinguished mother had it. “From the beginning, what the world wanted from bloody mother India was daylight-clear,” she’d say. “They came for the hot stuff, just like any man calling on a tart.”</span></p>
<p class="epc">—SALMAN RUSHDIE, <span class="epub-i">THE MOOR’S LAST SIGH</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraphs.vue?2fdf46aa